import React, { useRef, useState } from "react";
// import emailjs from "emailjs-com";
import { motion } from "framer-motion";

const LeadForm = () => {
  const form = useRef();
  const [status, setStatus] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const COOLDOWN_TIME = 1 * 60 * 1000; // 3 minutes in ms
  const [cooldown, setCooldown] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    const lastSubmit = localStorage.getItem("lead_last_submit");
    if (lastSubmit) {
      const remaining = COOLDOWN_TIME - (Date.now() - Number(lastSubmit));
      if (remaining > 0) {
        setCooldown(remaining);
      }
    }
  }, [COOLDOWN_TIME]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (cooldown <= 0) return;

    const timer = setInterval(() => {
      setCooldown((prev) => prev - 1000);
    }, 1000);

    return () => clearInterval(timer);
  }, [cooldown]);



  // 🔥 UPDATED: Firebase Cloud Function integration
  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus("");
    setError(false);
    setLoading(true);

    const payload = {
      clientId: "jPXJO4nQlth3Ii35vDOj3w7Qsvw1",
      customerName: form.current.user_name.value,
      phone: form.current.user_mobile.value,
      email: form.current.user_email.value,
      address: "",
      landmark: "",
      description: form.current.message.value,
      subject: "Website Lead - Cloud Consultation",
    };

    try {
      const response = await fetch(
        "https://submitrequest-soowmzlmsq-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("API Error");
      }

      setStatus("Thank you! We’ll get back to you within 30 Minutes.");
      form.current.reset();
      localStorage.setItem("lead_last_submit", Date.now().toString());
      setCooldown(COOLDOWN_TIME);
    } catch (err) {
      console.error(err);
      setStatus("Something went wrong. Please try again.");
      setError(true);
    } finally {
        setLoading(false); 
    }
  };

    const openLiveChatWindow = () => {
    const chatWindow = window.open(
      "",
      "LiveChat",
      "width=420,height=300,resizable=yes,scrollbars=no"
    );

    if (chatWindow) {
      chatWindow.document.write(`
        <html>
          <head>
            <title>Live Chat</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                background: #020617;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100vh;
                margin: 0;
                text-align: center;
              }
              .box {
                background: #0f172a;
                padding: 24px;
                border-radius: 12px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.4);
              }
              h3 {
                margin-bottom: 10px;
                color: #38bdf8;
              }
              p {
                font-size: 0.9rem;
                color: #c7d2fe;
              }
            </style>
          </head>
          <body>
          <div class="box">
            <h3>Live Chat</h3>
            <p>We apologize for the inconvenience.</p>
            <p>Our support team is currently assisting other customers.</p>
            <p>Please try again shortly.</p>
          </div>
        </body>
        </html>
      `);

      chatWindow.document.close();
    }
  };


  return (
    <section
      id="leadform"
      style={{
        position: "relative",
        padding: "40px 20px 50px",
        background: "linear-gradient(180deg, #0f172a 0%, #020617 100%)",
        color: "#fff",
        overflow: "hidden",
      }}
    >
      {/* Glow effects */}
      <div style={glow("#38bdf8", "10%", "25%")} />
      <div style={glow("#6366f1", "75%", "60%")} />

      <div style={{ maxWidth: "1150px", margin: "0 auto" }}>
        {/* Centered Header */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          style={{ textAlign: "center", marginBottom: "30px" }}
        >
          <h2 style={{ fontSize: "2.2rem", fontWeight: 800 }}>
            Get a <span style={gradientText}>Free Consultation</span>
          </h2>
          <p
            style={{
              marginTop: "5px",
              color: "#c7d2fe",
              fontSize: "1rem",
              maxWidth: "700px",
              margin: "10px auto 0",
              lineHeight: "1.4",
            }}
          >
            Tell us about your cloud requirements and our experts will reach out
            with a tailored solution.
          </p>
        </motion.div>

        {/* Two-column layout */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          {/* LEFT: Form */}
          <div style={{ flex: "1 1 400px", minWidth: "280px", maxWidth: "450px" }}>
            <motion.form
              ref={form}
              onSubmit={sendEmail}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              style={formCard}
            >
              <input
                type="text"
                name="user_name"
                placeholder="Your Name"
                required
                style={inputStyle}
              />
              <input
                type="tel"
                name="user_mobile"
                placeholder="Your Mobile Number"
                required
                style={inputStyle}
              />
              <input
                type="email"
                name="user_email"
                placeholder="Your Email"
                required
                style={inputStyle}
              />
              <textarea
                name="message"
                placeholder="Tell us about your cloud needs"
                rows="5"
                required
                style={inputStyle}
              />
              <button
                type="submit"
                style={{
                  ...buttonStyle,
                  opacity: loading || cooldown > 0 ? 0.6 : 1,
                  cursor: loading || cooldown > 0 ? "not-allowed" : "pointer",
                }}
                disabled={loading || cooldown > 0}
              >
                {loading
                  ? "Submitting..."
                  : cooldown > 0
                  ? `Next request in | ${Math.floor(cooldown / 60000)
                      .toString()
                      .padStart(2, "0")}:${Math.floor((cooldown % 60000) / 1000)
                      .toString()
                      .padStart(2, "0")} mins`
                  : "Submit"}
              </button>
              {status && (
                <p
                  style={{
                    marginTop: "12px",
                    textAlign: "center",
                    fontSize: "0.9rem",
                    color: error ? "#f87171" : "#4ade80",
                  }}
                >
                  {status}
                </p>
              )}

              <p
                style={{
                  marginTop: "12px",
                  fontSize: "0.75rem",
                  color: "#94a3b8",
                  textAlign: "center",
                }}
              >
                We respect your privacy. No spam. No obligations.
              </p>
            </motion.form>
          </div>

          {/* RIGHT: Contact Panel */}
          <div
            style={{
              flex: "0 0 220px",
              minWidth: "220px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              style={contactPanel}
            >
              <h4 style={panelTitle}>Need Instant Help?</h4>


              {/* Live Chat */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  style={contactItem("#38bdf8")}
                  onClick={openLiveChatWindow}
                >
                <span style={iconCircle("#38bdf8")}>🟢</span>
                <div>
                  <strong>Live Chat</strong>
                  <p style={slaText}>Response &lt; 1 mins</p>
                </div>
              </motion.div>

              {/* WhatsApp */}
              <motion.a
                href="https://wa.me/919345981014?text=Hi%2C%20I%20would%20like%20to%20discuss%20my%20cloud%20requirements."
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                style={{
                  ...contactItem("#22c55e"),
                  textDecoration: "none",
                  color: "#fff",
                }}
              >
                <span style={iconCircle("#22c55e")}>💬</span>
                <div>
                  <strong>WhatsApp</strong>
                  <p style={slaText}>Response &lt; 5 mins</p>
                </div>
              </motion.a>

              {/* Email */}
                <motion.a
                  href="mailto:support@radiancecloudsolutions.com?subject=Cloud%20Consultation%20Request"
                  whileHover={{ scale: 1.05 }}
                  style={{
                    ...contactItem("#6366f1"),
                    textDecoration: "none",
                    color: "#fff",
                  }}
                >
                <span style={iconCircle("#6366f1")}>✉️</span>
                <div>
                  <strong>Email Support</strong>
                  <p style={slaText}>Response &lt; 30 Mins</p>
                </div>
              </motion.a>

              <div style={slaNote}>
                ⏱️ <strong>Guaranteed SLA</strong>
                <br />
                Faster responses during business hours
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ---------- Styles ---------- */

const formCard = {
  maxWidth: "450px",
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  background: "rgba(15, 23, 42, 0.65)",
  backdropFilter: "blur(10px)",
  padding: "28px",
  borderRadius: "16px",
  border: "1px solid rgba(148,163,184,0.12)",
  boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
};

const inputStyle = {
  padding: "12px 3px",
  borderRadius: "8px",
  border: "1px solid #334155",
  background: "#020617",
  color: "#fff",
  fontSize: "0.92rem",
  outline: "none",
};

const buttonStyle = {
  marginTop: "8px",
  padding: "12px",
  borderRadius: "999px",
  border: "none",
  fontSize: "0.95rem",
  fontWeight: 600,
  cursor: "pointer",
  background: "linear-gradient(90deg,#38bdf8,#2563eb)",
  color: "#fff",
  boxShadow: "0 10px 25px rgba(56,189,248,0.35)",
};

const glow = (color, left, top) => ({
  position: "absolute",
  width: "380px",
  height: "380px",
  background: color,
  filter: "blur(140px)",
  opacity: 0.2,
  left,
  top,
});

const gradientText = {
  background: "linear-gradient(90deg,#38bdf8,#6366f1)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

/* Contact Panel Styles */

const contactPanel = {
  width: "100%",
  background: "rgba(15,23,42,0.65)",
  backdropFilter: "blur(12px)",
  borderRadius: "16px",
  padding: "18px",
  border: "1px solid rgba(148,163,184,0.15)",
  boxShadow: "0 15px 35px rgba(0,0,0,0.35)",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const panelTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  marginBottom: "6px",
  color: "#38bdf8",
  textAlign: "center",
};

const contactItem = (color) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px",
  borderRadius: "12px",
  background: "rgba(2,6,23,0.5)",
  border: `1px solid ${color}55`,
  cursor: "pointer",
});

const iconCircle = (color) => ({
  width: "34px",
  height: "34px",
  borderRadius: "50%",
  background: `${color}22`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1rem",
  color,
});

const slaText = {
  margin: 0,
  fontSize: "0.75rem",
  color: "#c7d2fe",
};

const slaNote = {
  marginTop: "6px",
  fontSize: "0.7rem",
  color: "#94a3b8",
  textAlign: "center",
};

export default LeadForm;
